__turbopack_context__.v({
  "card": "RedemptionPrizeOption-module__LyxuHa__card",
  "checkbox": "RedemptionPrizeOption-module__LyxuHa__checkbox",
  "prizeDescription": "RedemptionPrizeOption-module__LyxuHa__prizeDescription",
  "prizeTitle": "RedemptionPrizeOption-module__LyxuHa__prizeTitle",
  "textContainer": "RedemptionPrizeOption-module__LyxuHa__textContainer",
  "thumbnail": "RedemptionPrizeOption-module__LyxuHa__thumbnail",
});
